// extracted by mini-css-extract-plugin
module.exports = {"Comments":"Comments_Comments__2oRVF","Comments-Label":"Comments_Comments-Label__3BrzB","Comments-CommentInfo":"Comments_Comments-CommentInfo__2Celu"};